import { theme } from '@/styles';
import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export type FlagColorType = 'red' | 'yellow' | 'blue' | 'mono';
type FlagProps = {
  flagColor: FlagColorType;
  width?: string;
  height?: string;
  children?: ReactNode;
};

function Flag({
  flagColor,
  width = '54px',
  height = '21px',
  children,
}: FlagProps) {
  return (
    <FlagWrap flagColor={flagColor} width={width} height={height}>
      {children}
    </FlagWrap>
  );
}

const flagColors = {
  red: theme.colors.accent_colors.red.light,
  yellow: theme.colors.accent_colors.yellow.light,
  blue: theme.colors.accent_colors.blue.light,
  mono: theme.colors.neutral_colors.gray[50],
};

const flagColorStyle = css`
  ${({ flagColor }: { flagColor: FlagColorType }) => {
    return css`
      background-color: ${flagColors[flagColor]};
    `;
  }}
`;

const FlagWrap = styled.div<{
  flagColor: FlagColorType;
  width: string;
  height: string;
}>`
  /* common */
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 2px;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  min-width: ${({ width }) => width};
  min-height: ${({ height }) => height};
  color: ${theme.colors.accent_colors.primary.default};
  ${theme.typography.caption1};

  /* flag color style */
  ${flagColorStyle}
`;

export default Flag;
